<template>
  <div id="login" class="flex align-center justify-center">
    <div class="login-cantent flex flex-direction align-center">
      <div class="login-form flex flex-direction align-center" style="text-align: center;">
        <img src="../assets/img/logo.png" style="width:216px;height:46px;margin-bottom:40px" alt="">
        <el-form style="width:100%;text-align:center" :model="ruleForm" :rules="rules" ref="ruleForm"
        label-width="50px"
        class="demo-ruleForm">
          <el-form-item label="账号" prop="u">
            <el-input v-model="ruleForm.u"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="p">
            <el-input type="password" v-model="ruleForm.p" autocomplete="off"></el-input>
          </el-form-item>
            <el-button :disabled="isLogin" style="width:336px;margin-top:16px" type="primary" @click="submitForm('ruleForm')">登陆</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
      var phone = (rule, value, callback) => {
        const rpe = /^1[3-9]\d{9}$/
        if (value === '') {
          this.isLogin=true
          callback(new Error('请输入手机号'));
        } else if (!rpe.test(value)) {
          this.isLogin=true
          callback(new Error('手机号格式错误!'));
        } else {
          this.isLogin=false
          callback();
        }
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          this.isLogin=true
          callback(new Error('请输入密码'));
        } else {
          this.isLogin=false
          callback();
        }
      };
    return {
      ruleForm:{
        act:'projectLogin'
      },//表单数据
      rules:{
        u:[
          {
            validator: phone,
            trigger: 'blur' ,
          }
        ],
        p:[
            {
              validator: validatePass,
              trigger: 'blur'
            }
        ]
      },//验证规则
      isLogin:true,//禁用登陆按钮
    }
  },
  methods:{
    //登陆请求
    submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            localStorage.setItem('current',"1")
            this.$api.login.login_(this.ruleForm).then(res=>{
              if(res.code=='1'){
                localStorage.setItem('token',res.data.token)
                localStorage.setItem('u_name',this.ruleForm.u)
                this.$router.push("/")
              }else{
                this.$message({
                  type: 'error',
                  message: res.info
                });
              }
            })
          } else {
            return false
          }
        })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#login{
  width: 100%;
  background-image: url("../assets/img/loginbgc.png");
  background-size: cover;
  height: 1024px;
}
.login-form{
  width: 480px;
  height: 320px;
  background-color: #fff;
  padding: 24px;
  box-sizing: border-box;
  margin-bottom: 43px;
  border-radius: 6px;
}
</style>

<style>
#login .el-input__inner{
  border: none;
}
#login .el-form-item{
  border-bottom: 1px solid #F5F6F7;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue